const buttonHandlerMap = {
    GoBackButton: ['redirect:back'],
    GoForwardButton: ['redirect:foward'],
    JumpToOnePageButton: ['redirect:any'],
    PopFormButton: ['showPanel:form'],
    PopFormButtonAndRedirectToIndex: ['showPanel:form','redirect:index'],
    PopFormButtonAndRedirectToDetail: ['showPanel:form','redirect:detail'],
    PopFormButtonAndRedirectToAnyPage: ['showPanel:form','redirect:any'],

    PopSearchForm: ['showPanel:search'],
    sortBtn: ['showPanel:sort'],

    PopIframeButton: ['openWin:iframe'],
    PopComponentButton: ['showPanel:component','redirectAfterCompleteTask'],

    EditOwnerButton: ['showEditOwnerPanel:ownerform'],

    DeleteButton: ['confirmPop','ajaxMethod:delete'],
    DeleteButtonAndRedirectIndex: ['confirmPop','ajaxMethod:delete','redirect:index'],
    DeleteButtonAndRedirectToAnyPage: ['confirmPop','ajaxMethod:delete','redirect:any'],

    StaticButton: ['confirmPop','trigger','ajaxMethod'],
    LogicalDeleteButton: ['confirmPop','ajaxMethod:logic'],
    LogicalDeleteButtonAndRedirectIndex: ['confirmPop','ajaxMethod:logic','redirect:index'],
    EditBatchButton: ['showPanel:editBatch'],
    PopViewButton: ['showPanel:indexView']
};
export default buttonHandlerMap;



// WEBPACK FOOTER //
// ./src/components/Button/handlerMap.js